import React from "react";
import "./FoodTypeMark.css";

// The square-with-a-dot mark Indian menus use: green veg, amber egg, red
// non-veg. Values match types.FoodType on the backend; anything else (an item
// onboarded before the field existed) renders nothing rather than guessing.
export const FOOD_TYPES = {
    VEG: { label: "Veg", className: "food-mark--veg" },
    EGG: { label: "Egg", className: "food-mark--egg" },
    NON_VEG: { label: "Non-veg", className: "food-mark--nonveg" },
};

export default function FoodTypeMark({ foodType, size = 14, withLabel = false }) {

    const entry = FOOD_TYPES[foodType];

    if (!entry) {
        return null;
    }

    return (
        <span className="food-mark-wrap">
            <span
                className={`food-mark ${entry.className}`}
                style={{ width: size, height: size }}
                aria-label={entry.label}
                role="img"
            >
                <span className="food-mark-dot" />
            </span>
            {withLabel && <span className="food-mark-label">{entry.label}</span>}
        </span>
    );
}
